export enum ItemType {
  BUTTON = 'button',
  LINK = 'link',
  IMAGE = 'image',
}
